// React and Icons
import React, { useEffect, useState } from 'react'
import { MdEmail } from 'react-icons/md'
import { IoArrowBackOutline } from 'react-icons/io5'

// Components
import LoadingScreen from '../../../components/Loader'
import PageHeader from '../../../components/Custom/PageHeader/PageHeader'

// Hooks and Utils
import useGoBack from '../../../hooks/useGoBack'
import axiosInterceptorInstance from '../../../utils/axios/axiosInterceptorInstance'

const Profile = () => {
  const GoBack = useGoBack()
  const [isLoading, setIsLoading] = useState(true)
  const [userDetails, setUserDetails] = useState()

  const fetchUserDetails = async () => {
    try {
      const UserDetailsResponse = await axiosInterceptorInstance.post('/user')
      if (UserDetailsResponse.status === 201) {
        setUserDetails(UserDetailsResponse.data.result)
      }
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchUserDetails()
  }, [])

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <div>
      <PageHeader>
        <div className='flex gap-2 items-center font-medium'>
          <button
            onClick={GoBack}
            className='h-9 w-9 flex justify-center items-center rounded-full text-xl cursor-pointer transition-all duration-300 hover:text-white hover:bg-prime'
          >
            <IoArrowBackOutline />
          </button>
          <h1 className='text-2xl'>Profile</h1>
        </div>
      </PageHeader>
      <section className='py-6 '>
        <div className='container  mx-auto'>
          <div className='flex  items-center gap-2'>
            <div className='bg-prime p-3 rounded-full text-white'>
              <MdEmail className='text-2xl ' />
            </div>
            <p className='text-sm font-semibold'>{userDetails?.email || ''}</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Profile
